import * as React from "react"
import {useRef, useState} from "react"
import {useLocation, matchPath} from "react-router-dom";
import {List} from "@mui/material";

import {AppLink, AppPopoverNav} from "../../../../../@componets";
import {navWidthMini} from "../../../../../@signals";
import MaximalLayoutNavMiniItem from "./NavItem";
import {signal, useComputed} from "@preact/signals-react";


const sectionOpened = signal(null)

export default function MaximalLayoutNavMiniNavList({ path, routes, sx={}, ...config }) {

    const navRef = useRef(null)
    const [anchorEl, setAnchorEl] = useState(null)
    const hasChildren = routes && routes.filter(item => !item.index && !item.noMenu).length > 1 && path !== '/'

    // Group routes have no `path` (only `title`), so key the open state by a
    // stable unique id; otherwise every group shares `undefined` and opens together.
    const navId = path ?? config.title

    const { pathname } = useLocation()
    // Highlight the parent icon whenever one of its listed children is the active route (`noMenu`: listed elsewhere).
    const childActive = hasChildren && routes?.some(r => r.path && r.path !== 'divider' && !r.noMenu && matchPath({ path: r.path, end: false }, pathname))

    // Anchor to the real DOM node from the event, never to a stale ref snapshot.
    // If anchorEl were null, MUI Popover falls back to document.body and the
    // panel jumps to the far right of the viewport, leaving an open modal that
    // blocks every click until reload.
    const handleMouseEnter = e => {
        if (e?.currentTarget) setAnchorEl(e.currentTarget)
        sectionOpened.value = navId
    }
    const handleMouseLeave = () => sectionOpened.value = null
    const handleClose = () => sectionOpened.value = null
    const keepOpen = () => sectionOpened.value = navId
    const isOpen = useComputed(() => sectionOpened.value === navId)

    return <List ref={navRef} sx={{ width: `${navWidthMini.value - 16}px`, ...sx.list }}>
        <AppLink to={path} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} {...config?.pathConfig}>
            <MaximalLayoutNavMiniItem path={path} hasChildren={hasChildren} sx={sx.item} {...config} active={hasChildren ? childActive : undefined} />
        </AppLink>

        { hasChildren && <AppPopoverNav
            routes={routes}
            isOpen={isOpen.value && !!anchorEl}
            handleMouseEnter={keepOpen}
            handleMouseLeave={handleMouseLeave}
            handleClose={handleClose}
            anchorEl={anchorEl}
            sx={sx.popover}
        /> }
    </List>
}